module.exports = ".account-configurations-container {\n\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-configurations/account-configurations.component.css
// module id = ./src/app/agora/components/account-configurations/account-configurations.component.css
// module chunks = main